import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Element, scroller } from 'react-scroll';
import defer from 'lodash/defer';

import Button from 'common/button';
import Icon from 'common/icon';

const TypeCard = ({
    type,
    title,
    description,
    buttonLabel,
    expanded,
    onExpand,
    onSelect,
    disabled,
}) => {
    const scrollId = `js-scroll-${type}`;
    const handleExpand = () => {
        onExpand();

        // Have to defer this so any previous collapsing
        // happens before it calculates how far it needs
        // to scroll
        defer(() => {
            scroller.scrollTo(scrollId, {
                duration: 500,
                smooth: true,
                offset: -175,
            });
        });
    };

    return (
        <div
            className={cx('bg-white flex flex-col flex-1 justify-between', {
                'shadow-md': !disabled,
                shadow: disabled,
            })}
        >
            <div className="p-8 lg:p-10">
                <Element name={scrollId} />
                <div
                    className="flex justify-between items-start"
                    onClick={handleExpand}
                    role="presentation"
                >
                    <div className="flex-grow">
                        <h2
                            className={cx('text-21 font-bold', {
                                'text-gray-70': !disabled,
                                'text-gray-40': disabled,
                            })}
                        >
                            {title}
                        </h2>
                    </div>
                    {!expanded && (
                        <div className="flex-no-shrink pt-px">
                            <button
                                type="button"
                                onClick={handleExpand}
                                className="link-gray text-21 mt-px"
                            >
                                <Icon icon="chevron-circle-down" />
                            </button>
                        </div>
                    )}
                </div>
                {expanded && (
                    <p
                        className={cx('mt-2 text-16 leading-relaxed md:leading-loose', {
                            'text-gray-50': !disabled,
                            'text-gray-40': disabled,
                        })}
                    >
                        {description}
                    </p>
                )}
            </div>
            {expanded && !disabled && (
                <Button
                    color="green"
                    size="lg"
                    className="block w-full font-medium rounded-none text-16 px-0"
                    onClick={onSelect}
                >
                    {buttonLabel}
                </Button>
            )}
        </div>
    );
};

TypeCard.propTypes = {
    type: PropTypes.oneOf(['pledge', 'donation']).isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    expanded: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    onExpand: PropTypes.func.isRequired,
    buttonLabel: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

TypeCard.defaultProps = {
    disabled: false,
};

export default TypeCard;
